export function XML_Cmd1(theCmd, param1, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementPair("cm", theCmd, param1, s);
}
